// TOFIX: peerjs not working with webpack
// import Peer from "peerjs/dist/peerjs.min.js";


// import Peer from "peerjs";
import { customLogger } from "@/utils";

const state = {
  display_video_chat: false,
  display_messages: false,
  messages: [],
  messageNotif: false,
  remoteMedia: {
    video: true,
    audio: true,
  },
  GetCall: false,
  myPeer: undefined,
  remotePeerId: null,
  socketAddr: undefined,
  peercall: undefined,
  stream: undefined,
  screen_sharing: false,
};

async function enableVideoStream(options) {
  return new Promise((resolve, reject) => {
    navigator.mediaDevices
      .getUserMedia(options)
      .then((stream) => {
        window.stream = stream;
        resolve(stream);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

const actions = {
  initPeer: ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      // const peer = new Peer({
      //   host: "peers-server.cleed.ai",
      //   // host: "localhost",
      //   port: 443,
      //   path: "/CleedPeer/cleed_VC",
      //   debug: 2,
      //   secure: true,
      // });
      resolve({});
    });
  },
  EndCall: ({ state, commit }) => {
    state.socketAddr.emit(
      "USER_endCall",
      { message: "user end the call" },
      (cb) => {
        if (typeof cb === "string") {
          customLogger(cb);
        } else if (cb.success == false) {
          customLogger(cb.messages);
        } else {
          state.display_video_chat = false;
          state.display_messages = false;
        }
      }
    );
  },
  CancelCall: ({ state, commit, dispatch }) => {
    state.socketAddr.emit(
      "USER_cancelCall",
      { message: "user cancel the call" },
      (cb) => {
        if (typeof cb === "string") {
          customLogger(cb);
        } else if (cb.success == false) {
          customLogger(cb.messages);
        } else {
          state.GetCall = false;
          dispatch('CLOASE_STREAM')
        }
      }
    );
  },
  VIDEO_SOCKET_GettingCall: async ({ state, commit, dispatch }, id) => {
    customLogger("peer ID", id);
    await enableVideoStream({ audio: true, video: true })
      .then((stream) => {
        state.stream = stream;
      })
      .catch((err) => {
        customLogger(err);
      });
    await dispatch("initPeer").then(async (peer) => {
      state.remotePeerId = id;
      state.GetCall = true;
      state.myPeer = peer;
      state.remoteMedia = {
        video: true,
        audio: true,
      };
      state.messages = [];
    });
    state.socketAddr.emit("VIDEO_CHAT_UserJoinRoom");
  },
  CLOASE_STREAM: ({ state, commit }) => {
    let stream = state.stream || window.stream;
    stream.getTracks().forEach((track) => {
      customLogger("stop ", { track });
      track.stop();
    });
    stream = null;

    customLogger("dispatch CLOASE_STREAM", state.peercall);
    if (state.peercall) {
      state.peercall.close();
    }
  },
  VIDEO_SOCKET_ADMIN_end_calling: ({ state, commit, dispatch }, data) => {
    customLogger("ADMIN_end_calling");
    state.socketAddr.emit("VIDEO_CHAT_UserLeaveRoom");
    dispatch('CLOASE_STREAM')
    state.GetCall = false;
    state.display_video_chat = false;
    state.display_messages = false;
    state.remotePeerId = null;
    if (state.peercall) state.peercall.close();
  },
  VIDEO_SOCKET_ADMIN_send_message: ({ state, commit, rootState }, data) => {
    if (!state.display_messages) {
      state.messageNotif = true;
    }
    commit("new_message", { data, rootState });
  },
  VIDEO_SOCKET_My_send_message: ({ state, commit, rootState }, data) => {
    if (data) {
      state.messages.push(data);
      rootState.user.messages.push(data);
    }
  },
};

const mutations = {
  VIDEO_SOCKET_ADMIN_mediaDevices_Change: (state, data) => {
    state.remoteMedia.video = data.video;
    state.remoteMedia.audio = data.audio;
  },
  new_message: (state, { data, rootState }) => {
    state.messages.push(data);
    rootState.user.messages.push(data);
  },
  ENABLE_SCREEN_SHARE: (state, data) => {
    state.screen_sharing = data.share;
  },
};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters,
};
